import cx from 'classnames';
import { ReactNode } from 'react';
import { Card } from '@/components/Card';
import styles from './TitledCard.module.css';

export const TitledCard = ({
  title,
  children,
  className,
}: {
  title: string;
  children: ReactNode;
  className?: string;
}) => {
  return (
    <Card className={cx(styles.TitledCard, className)}>
      <h3 className={styles.title}>
        {title}
      </h3>
      <div className={styles.value}>
        {children}
      </div>
    </Card>
  );
};
